<div class="d-flex">
  @for (item of statisticItems; track item) {
    <ng-container [ngTemplateOutlet]="statisticTemplate" [ngTemplateOutletContext]="{ item: item }">
    </ng-container>
  }

</div>

<ng-template #statisticTemplate let-item="item">
  <div class="tenant-statistic__container" *hasPermission="item.permission" >
    <div class="d-flex flex-row p-1 p-lg-2 p-xxl-3 tenant-statistic-div">
      <div class="text-start cursor-pointer stats-hover {{item.dynamicClass}}">
        <a routerLink="{{item.url}}" class="position-relative" (click)="statsButtonClicked(item.title)">
          <div class="d-flex flex-column text-center align-items-center">
            <div class="statistic-icon__container btn-circle" [attr.id]="item.key" [innerHTML]="item.icon | SafeHTML">
            </div>
            <span class="text-dark">{{item.title}}</span>
          </div>
        </a>
      </div>
      <div class="d-flex align-items-center justify-content-center stats-number-div">
        @if (!(isTenantStatisticsLoading$ | async)) {
          @if (statistics) {
            <span class="stats-number">
              {{ statistics[item.key] | number }}
            </span>
          } @else {
            <span class="text-dark">0</span>
          }
        } @else {
          <div class="">
            <span class="spinner spinner-primary spinner-track spinner-sm"></span>
          </div>
        }
      </div>
    </div>
  </div>
</ng-template>  


